import { render, staticRenderFns } from "./SalesforceChatScript.vue?vue&type=template&id=98199796"
import script from "./SalesforceChatScript.vue?vue&type=script&lang=ts"
export * from "./SalesforceChatScript.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports